import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { PasswordResetForm } from 'containers/forms/auth'
import { meta } from 'helpers/decorators'

@meta({ title: 'Password reset', intlKey: 'route.password_reset' })
class PasswordReset extends Component {
  static propTypes = {
    location: PropTypes.object
  }

  render() {
    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[<PasswordResetForm location={this.props.location} />]}
        colWidth="305px"
      />
    )
  }
}

export default PasswordReset
